import {Button, ButtonStyles, ButtonType} from "../../../lib/form/Button/Button";
import {LoginMode} from "../../Checkout";
import Spinner from "../../../utils/loader/Spinner";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {useCartContext} from "../../../cart/CartContextProvider/CartContextProvider";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import styles from "./GuestCustomer.module.scss";
import {useState} from "react";
import {Payments} from "../../../lib/payments/PaymentController";
import {ICheckoutPutParams} from "../../../../typescript-library";

const GuestCustomer: React.FC = () => {
  const {t} = useTranslation();
  const {checkout} = useCheckoutContext();
  const {viewState, setViewState} = useCartContext();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className={styles.guestOrder}>
      <h3>{t("checkout.createNoAccount")}</h3>
      <p>{t("checkout.orderWithoutAccount")}</p>
      <Button
        btnIdentifier={LoginMode.NEWCUSTOMER}
        type={isLoading ? ButtonType.disabled : ButtonType.outlined}
        action={(evt) => {
          evt.preventDefault();
          setViewState({...viewState, isRegistering: true});
          setIsLoading(true);
          const paramsToPut: ICheckoutPutParams = {
            isGuest: true,
          };
          if (
            [Payments.ApplePay, Payments.GooglePay, Payments.PaypalExpressBraintree].includes(
              checkout.paymentId as Payments,
            )
          ) {
            paramsToPut.paymentId = null;
          }
          void checkout.put(paramsToPut);
        }}
        styles={[ButtonStyles.big]}
      >
        {isLoading ? <Spinner /> : <span>{t("checkout.orderAsGuest")}</span>}
      </Button>
    </div>
  );
};

export default GuestCustomer;
